// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__3e9Gr","content":"Modal_content__ktHjK","emoji":"Modal_emoji__3NBga","text":"Modal_text__10KpM"};